import template from './sw-customer-detail.html.twig';

const { Component, Store, Classes } = Shopware;

const DUPLICATE_EMAIL_CODE = 'VIOLATION::CUSTOMER_EMAIL_NOT_UNIQUE';

Component.override('sw-customer-detail', {
    template,

    watch: {
        'customer.email'() {
            this.clearDuplicateEmailError();
        },

        editMode(enabled) {
            if (!enabled) {
                this.clearDuplicateEmailError();
            }
        },
    },

    methods: {
        onSave() {
            const savePromise = this.$super('onSave');

            if (!savePromise || typeof savePromise.catch !== 'function') {
                return savePromise;
            }

            return savePromise.catch((exception) => {
                this.handleSaveError(exception);
                throw exception;
            });
        },

        handleSaveError(exception) {
            if (!this.customer || !this.customer.id) {
                return;
            }

            const errors = exception && exception.response && exception.response.data
                ? exception.response.data.errors
                : [];

            const emailViolation = errors.find((error) => (
                error.code === DUPLICATE_EMAIL_CODE
                || (error.source && error.source.pointer === '/email')
            ));

            if (!emailViolation) {
                return;
            }

            Store.get('error').addApiError({
                expression: `customer.${this.customer.id}.email`,
                error: new Classes.ShopwareError({
                    code: DUPLICATE_EMAIL_CODE,
                    detail: this.$tc('TopdataContactLoginSW6.admin.customerEmailNotUnique'),
                }),
            });

            this.createNotificationError({
                message: this.$tc('TopdataContactLoginSW6.admin.customerEmailNotUnique'),
            });
        },

        clearDuplicateEmailError() {
            if (!this.customer || !this.customer.id) {
                return;
            }

            Store.get('error').removeApiError(`customer.${this.customer.id}.email`);
        },
    },
});